export class WalletAddressEntity {
  cryptoNetworkId: number;
  id: number;
  address: string;
  walletType: WalletType;
  isVerified: boolean | null;
  userId: string;
  createdAt: Date | null;
  updatedAt: Date | null;
  influencerId: number;
}

export enum WalletType {
  SMART = 'SMART',
  MAIN = 'MAIN',
  RECOVERY = 'RECOVERY',
  ADDITIONAL = 'ADDITIONAL',
  INFLUENCER = 'INFLUENCER',
}
